// @ts-nocheck
import { Light as SyntaxHighlighter } from "react-syntax-highlighter";
import bash from "react-syntax-highlighter/dist/cjs/languages/hljs/bash";
import js from "react-syntax-highlighter/dist/cjs/languages/hljs/javascript";
import tomorrowNightStyle from "react-syntax-highlighter/dist/cjs/styles/hljs/tomorrow-night";

import { Container } from "@/components/LandingPage/Container";
import analytics from "@/utils/analytics/analytics";

SyntaxHighlighter.registerLanguage("bash", bash);
SyntaxHighlighter.registerLanguage("javascript", js);

const CURL_SAMPLE = `curl -X POST "https://api.myjson.online/v2/records" \\
  -H "Content-Type: application/x-www-form-urlencoded" \\
  -H "x-collection-access-token: YOUR_COLLECTION_ACCESS_TOKEN" \\
  -d "collectionId=YOUR_COLLECTION_ID" \\
  -d 'jsonData={"hello":"world"}'`;

const FETCH_SAMPLE = `const res = await fetch("https://api.myjson.online/v2/records", {
  method: "POST",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
    "x-collection-access-token": "YOUR_COLLECTION_ACCESS_TOKEN",
  },
  body: new URLSearchParams({
    collectionId: "YOUR_COLLECTION_ID",
    jsonData: JSON.stringify({ hello: "world" }),
  }),
});

const data = await res.json();
console.log(data);`;

function CodePanel({
  title,
  language,
  code,
}: {
  title: string;
  language: string;
  code: string;
}) {
  return (
    <div className="overflow-hidden rounded-xl border border-[#5E5176] bg-[#141414] shadow-lg">
      <div className="flex items-center justify-between border-b border-[#2a2a2a] bg-black px-4 py-2">
        <div className="flex gap-1.5">
          {["#ed6b5f", "#f5bf4f", "#64b755"].map((color, i) => (
            <div
              key={i}
              className="h-3 w-3 rounded-full"
              style={{ backgroundColor: color }}
            />
          ))}
        </div>
        <span className="text-xs text-gray-500">{title}</span>
      </div>
      <SyntaxHighlighter
        language={language}
        style={tomorrowNightStyle}
        customStyle={{
          margin: 0,
          padding: "1rem 1rem 1.25rem",
          background: "#1d1f21",
          fontSize: "0.75rem",
          lineHeight: 1.5,
        }}
        showLineNumbers
      >
        {code}
      </SyntaxHighlighter>
    </div>
  );
}

export function DeveloperApiPreview() {
  return (
    <section
      id="api-preview"
      aria-label="API code examples"
      className="relative pb-8 pt-4 sm:pb-12 sm:pt-8"
    >
      <Container>
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
            API at a glance
          </h2>
          <p className="mt-3 text-sm text-gray-400 sm:text-base">
            Swap in your collection token and IDs after signup. These are the same
            endpoints you use in production, so you know exactly what you are integrating.
          </p>
          <a
            href="https://docs.myjson.online/"
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 inline-block text-sm font-medium text-purple underline transition-colors hover:text-purple/80"
            onClick={() => analytics.track("click_documentation", { from: "api_preview" })}
          >
            Full documentation
          </a>
        </div>
        <div className="mx-auto mt-10 grid max-w-5xl gap-6 lg:grid-cols-2">
          <CodePanel title="cURL" language="bash" code={CURL_SAMPLE} />
          <CodePanel title="JavaScript (fetch)" language="javascript" code={FETCH_SAMPLE} />
        </div>
      </Container>
    </section>
  );
}
